import React from 'react';
import logoHead from "../../images/Logo_head_white.png";
import './Welcome.css';

export default function Header({ isMobile }) {
  return (
    <header className="welcome-header">
      <img
        src={logoHead}
        alt="NeuHawk logo"
        className={`logo ${isMobile ? 'mobile' : ''}`}
      />
      <h1 className={`main-title ${isMobile ? 'mobile' : ''}`}>
        NeuHawk
      </h1>
    </header>
  );
}